import { useDispatch } from 'react-redux';

import { EVENT } from '../../analytics/analyticsConsts';
import { URL } from '../../api/apiConstants';
import { MODAL_ENUM, setShowModal } from '../../app/applicationScreenSlice';
import { useAppSelector, useImpState } from '../../app/hooks';
import cirleOne from '../../assets/images/circle-one.png';
import cirleThree from '../../assets/images/circle-three.png';
import cirleTwo from '../../assets/images/circle-two.png';
import { ANALYTICS } from '../../firebase/firebase';
import styles from './OtpVerify.module.css';

export default function UnfreezeCreditModal() {
  const dispatch = useDispatch();
  const { language } = useImpState();
  const expiresAt = useAppSelector(
    (state) => state.applicationStatusSelector.expiresAt
  );

  if (language === null) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button
          className={styles.close}
          onClick={() => dispatch(setShowModal(MODAL_ENUM.noModal))}
        ></button>
        <p className={styles.header}>{language.unfreezeCreditHeader}</p>
        <div className={styles.divPoint}>
          <img alt="number1" className={styles.circleNum} src={cirleOne} />
          <a
            href={URL.TRANSUNION}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              ANALYTICS.logEvent(EVENT.FROZEN_CREDIT_LINK_CLICKED, {
                link: 'log_in',
              })
            }
            className={styles.link}
          >
            {language.logIn}
          </a>
          <p className={styles.bulletInlineText}>
            {language.unfreezeCreditBullet1}
          </p>
        </div>
        <div className={styles.divPoint}>
          <img alt="number2" className={styles.circleNum} src={cirleTwo} />
          <p className={styles.bulletText}>{language.unfreezeCreditBullet2}</p>
        </div>
        <div className={styles.divPoint}>
          <img alt="number3" className={styles.circleNum} src={cirleThree} />
          <p className={styles.bulletText}>{language.unfreezeCreditBullet3}</p>
        </div>
        <div className={styles.divPoint}>
          <p className={styles.bulletInlineText}>
            {language.unfreezeCreditBody1}
            {expiresAt}
          </p>
          <p className={styles.bulletInlineText}>
            {language.unfreezeCreditBody2}
          </p>
        </div>
        <div className={styles.divPoint}>
          <p className={styles.bulletInlineText}>
            {language.unfreezeCreditBody3}
          </p>
          <a
            href={URL.ARTICLE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              ANALYTICS.logEvent(EVENT.FROZEN_CREDIT_LINK_CLICKED, {
                link: 'this_article',
              })
            }
            className={styles.linkInline}
          >
            {language.unfreezeCreditBody4}
          </a>
          <p className={styles.bulletInlineText}>
            {language.unfreezeCreditBody5}
          </p>
        </div>
      </div>
    </div>
  );
}
